import { SVGProps } from 'react';

const NonBinary = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 2v10m0 0a5 5 0 1 0 0 10 5 5 0 0 0 0-10M8.5 4l7 4m-7 0 7-4"
    />
  </svg>
);
export default NonBinary;
